export const getLoaderSize = size => {
  if (size === 'l' || size === 'm') {
    return 's';
  }
  return 'xs';
};